import React from 'react';
import { Paper, Box } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

function FunnelSkeleton({ classes }) {
    return (
        <Paper className={classes.funnelCard}>
            <Skeleton 
                variant="text" 
                width="40%" 
                height={40} 
                style={{ marginBottom: '24px' }} 
                animation="wave" 
            />
            
            <div className={classes.funnelContainer}>
                {[1, 2, 3, 4].map((item, index) => (
                    <div key={item} className={classes.skeletonStage}>
                        <div className={classes.funnelBarContainer}>
                            <Skeleton 
                                variant="rect" 
                                height={60} 
                                style={{ 
                                    borderRadius: 8,
                                    width: `${100 - (index * 15)}%` 
                                }} 
                                animation="wave" 
                            />
                        </div>
                        <div className={classes.funnelInfo}>
                            <Skeleton 
                                variant="text" 
                                width={80} 
                                height={30} 
                                animation="wave" 
                            />
                            <Skeleton 
                                variant="text" 
                                width={120} 
                                height={20} 
                                style={{ marginTop: '8px' }} 
                                animation="wave" 
                            />
                        </div>
                    </div>
                ))}
            </div>

            {/* Insights Skeleton */}
            <Box className={classes.insightsSection}>
                <Skeleton 
                    variant="text" 
                    width="30%" 
                    height={35} 
                    style={{ marginBottom: '24px' }} 
                    animation="wave" 
                />
                <div className={classes.insightsGrid}>
                    {[1, 2, 3, 4, 5].map((item) => (
                        <div key={item} className={classes.insightItem}>
                            <Skeleton 
                                variant="text" 
                                width="60%" 
                                height={20} 
                                style={{ marginBottom: '8px' }} 
                                animation="wave" 
                            />
                            <Skeleton 
                                variant="text" 
                                width="80%" 
                                height={30} 
                                animation="wave" 
                            />
                        </div>
                    ))}
                </div>
            </Box>
        </Paper>
    );
}

export default FunnelSkeleton;